export const FgPriceListColumns = [
    "SNo",
    "Product",
    'MinPrice', 
    'MidPrice', 
    'HighPrice', 
'Category'
  
]